let captured: string | null = null;

export const captureInitialUrlSearch = (): void => {
    if (captured !== null || typeof document === 'undefined') {
        return;
    }
    captured = document.location.search;
};

export const getInitialUrlSearch = (): string => captured ?? '';
